import { UserPermissionLevelSelect } from 'components/user/user-permission-level-select/user-permission-level-select'
import { UserPermissionResourceSelect } from 'components/user/user-permission-resource-select/user-permission-resource-select'
import { UserPermissionTypeSelect } from 'components/user/user-permission-type-select/user-permission-type-select'
import { InheritedPermissions } from 'components/user/user-permission-list/user-permission-list'
import { PermissionLevel, PermissionType } from 'types'
import { useState } from 'react'
import { Loading, PageError } from 'components/styled'
import { useCurrentShop } from 'api'
import { UserPermissionLocationSelect } from '../user-permission-location-select/user-permission-location-select'

enum Content {
    None,
    PermissionTypeSelect,
    PermissionLevelSelect,
    LocationSelect,
    ServiceSelect,
    ResourceSelect,
    FlowSelect
}

type Props = {
    inheritedPermissions: InheritedPermissions
    onAdd: (permission: string) => void
    onBack: () => void
}

export const UserPermissionRouter = ({ inheritedPermissions, onAdd, onBack }: Props) => {

    //shop:
    const { data: shop, isLoading } = useCurrentShop()

    //state:
    const [ content, setContent ] = useState(Content.PermissionTypeSelect)
    const [ previousContent, setPreviousContent ] = useState(Content.None)
    const [ permission, setPermission ] = useState<string | null>(null)
    
    //handleTypeSelect:
    const handleTypeSelect = (type: PermissionType) => {
        setPreviousContent(Content.PermissionTypeSelect)
        switch(type){
            case PermissionType.Shop:
                setPermission(`${PermissionType.Shop}:${shop ? shop.id : ''}`)
                setContent(Content.PermissionLevelSelect)
                break
            case PermissionType.Location:
                setContent(Content.LocationSelect)
                break
            // case PermissionType.Service:
            //     setContent(Content.ServiceSelect)
            //     break
            case PermissionType.Resource:
                setContent(Content.ResourceSelect)
                break
            case PermissionType.Appointment:
                setPermission(`${PermissionType.Appointment}:All`)
                setContent(Content.PermissionLevelSelect)
                break
            // case PermissionType.Flow:
            //     setContent(Content.FlowSelect)
            //     break
        }
    }

    //handleValueSelect:
    const handleValueSelect = (permission: string, currentContent: Content) => {
        setPermission(permission)
        setPreviousContent(currentContent)
        setContent(Content.PermissionLevelSelect)
    }

    //handleLevelSelect:
    const handleLevelSelect = (permission: string, level: PermissionLevel) => {
        onAdd(`${permission}:${level}`)
        setPermission(null)
        setTimeout(() => {
            setContent(Content.PermissionTypeSelect)
            setPreviousContent(Content.None)
        }, 500)
        onBack()
    }

    //handleObjectBack:
    const handleObjectBack = () => {
        setPermission(null)
        setContent(Content.PermissionTypeSelect)
        setPreviousContent(Content.None)
    }

    //handleLevelBack:
    const handleLevelBack = (previousContent: Content) => {
        setPermission(null)
        setContent(previousContent)
        setPreviousContent(Content.PermissionTypeSelect)
    }

    return isLoading ? <Loading/> : !shop ? <PageError/> : (

        <div style={{ height: '100%' }}>
            
            {content === Content.PermissionTypeSelect ? (

                <UserPermissionTypeSelect
                    inheritedPermissions={inheritedPermissions}
                    onSelect={type => handleTypeSelect(type)}
                    onBack={onBack}
                />
            
            ) : content === Content.LocationSelect ? (

                <UserPermissionLocationSelect
                    onSelect={id => handleValueSelect(`${PermissionType.Location}:${id ?? 'All'}`, Content.LocationSelect)}
                    onBack={handleObjectBack}
                />
            
            ) : content === Content.ServiceSelect ? (
                <></>
                // <UserPermissionServiceSelect
                //     onSelect={id => handleValueSelect(`${PermissionType.Service}:${id ?? 'All'}`, Content.ServiceSelect)}
                //     onBack={handleObjectBack}
                // />
            
            ) : content === Content.ResourceSelect ? (

                <UserPermissionResourceSelect
                    onSelect={id => handleValueSelect(`${PermissionType.Resource}:${id ?? 'All'}`, Content.ResourceSelect)}
                    onBack={handleObjectBack}
                />
            
            ) : content === Content.FlowSelect ? (
                <></>
                // <UserPermissionFlowSelect
                //     onSelect={id => handleValueSelect(`${PermissionType.Flow}:${id ?? 'All'}`, Content.FlowSelect)}
                //     onBack={handleObjectBack}
                // />
            
            ) : (

                <UserPermissionLevelSelect
                    onSelect={level => {permission && handleLevelSelect(permission, level)}}
                    onBack={() => handleLevelBack(previousContent)}
                />

            )}
        
        </div>
    )
    
}
